<template>
  <EInstantAnswer
    class=""
    data-test-id="MyIP"
    :feedback-link="{
      ticketSubject: 'Rich Content - My IP',
      widgetType: 'my_ip_rich'
    }"
    trees
    powered-by-ecosia
  >
    <template #context>
      {{ $t('web.widgets.myip.context') }}
    </template>
    <template #title>
      <div class="my-ip__title" data-test-id="ip-address">
        {{ userIp }}
      </div>
    </template>
    <template #default>
      <div class="my-ip__body">
        {{ $t('web.widgets.myip.body') }}
      </div>
      <div class="my-ip__links">
        <ELinkBubble
          data-test-id="helpcenter-link"
          :href="myIPhelpcenterURL"
          :target="linkTarget"
          rel="noopener"
          color="result"
          class="my-ip__helpcenter-link"
        >
          <EIcon icon="logo-compact" size="s" />
          {{ $t('web.widgets.myip.linktext') }}
        </ELinkBubble>
      </div>
    </template>
  </EInstantAnswer>
</template>

<script>
import { mapGetters } from 'vuex';

import { trackImpression, PAGE_SERP, TYPE_RICH } from '~~/search/common/js/client/analytics/rich-content';
import EIcon from '~~/common/vue/components/icon';
import EInstantAnswer from '~/components/instant-answers/base';
import ELinkBubble from '~~/common/vue/components/link-bubble';
import { MYIP_HELPCENTER } from '~~/common/js/constants/urls';

export const TRACK_ID = 'my_ip';

export default {
  name: 'EMyIP',
  components: {
    EInstantAnswer,
    ELinkBubble,
    EIcon,
  },
  props: {
    userIp: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['linkTarget']),
    myIPhelpcenterURL() {
      return MYIP_HELPCENTER;
    },
  },
  mounted() {
    trackImpression({
      name: TRACK_ID,
      page: PAGE_SERP,
      type: TYPE_RICH,
      once: false,
    });
  },
};
</script>

<style lang="scss" scoped>

.my-ip__title {
  margin-bottom: $space-m;
}

.my-ip__body {
  margin-bottom: $space-m;
}

.my-ip__links {
  display: flex;
}

.my-ip__helpcenter-link {
  font-size: $font-m;
  gap: $space-1s;
}

</style>
